export default {
  inject: ['load'],
  data() {
    return {
      allDiagnosisBaseDatas: [],
    };
  },
  methods: {
    getAllDiagnosisBaseDatas: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDiagnosisBaseDatas').then(() => {
        if (this.$store.state.diagnosisBaseDataModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allDiagnosisBaseDatas =
            this.$store.state.diagnosisBaseDataModule.allDiagnosisBaseDatas;
          if (this.$route.name == 'hospital') {
            if (this.showAddEditModal == false) {
              this.allHospitalDiagnosisBaseDatas = this.allDiagnosisBaseDatas;
              this.readyHospitalDiagnosisBaseData();
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.diagnosisBaseDataModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.diagnosisBaseDataModule.successFlag) {
                this.getAllDiagnosisBaseDatas();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.diagnosisBaseDataModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllDiagnosisBaseDatas();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.diagnosisBaseDataModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
